import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { map } from 'lodash';
import { toast } from 'react-toastify';
import DatePickerField from '../Formik/DatePickerField';
import { Submit } from '../Formik/Submit';
import SelectField from '../Formik/SelectField';
import { shareCar } from '../../actions/carActions';
import JumpingWoman from '../../assets/img/jumping-woman.svg';

function ShareCarPage({ location }) {
  const [isSent, setSent] = useState(false);
  const car = location.state;
  const users = useSelector((state) =>
    map(state.users, (user) => ({
      label: `${user.firstName} ${user.lastName}`,
      value: user.id
    }))
  );
  const dispatch = useDispatch();
  const today = new Date();

  const ShareCarSchema = Yup.object().shape({
    user: Yup.number().min(0),
    dateFrom: Yup.date().required(),
    dateTo: Yup.date().required()
  });

  async function handleSubmit(values) {
    try {
      await dispatch(
        shareCar({
          car: car.carId,
          userTo: values.user,
          dateFrom: moment(values.dateFrom).format('DD.MM.YYYY'),
          dateTo: moment(values.dateTo).format('DD.MM.YYYY')
        })
      );
      setSent(true);
    } catch (err) {
      if (err.response.data.message) {
        toast.error(err.response.data.message);
      }
    }
  }

  if (isSent) {
    return (
      <div className="relative">
        <div className="h4 center pb2">
          Děkujeme že sdílíte své auto s ostatními,
          <br />
          určitě to Váš kolega ocení!
        </div>
        <img
          className="juping-woman"
          src={JumpingWoman}
          alt="Radující se žena"
        />
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-center text-red">
        {car.brand} - {car.plateNo}
      </h2>
      <p className="text-center h4 mb2">
        Tohle je vaše auto,
        <br /> v jakém termínu ho chcete uživateli sdílet?
      </p>
      <Formik
        initialValues={{
          user: null,
          dateFrom: today,
          dateTo: today
        }}
        onSubmit={handleSubmit}
        validationSchema={ShareCarSchema}
      >
        <Form>
          <div className="flex">
            <div className="col-1" />
            <div className="col-10">
              <SelectField
                name="user"
                label="Uživatel"
                options={users}
                searchable
              />
            </div>
            <div className="col-1" />
          </div>
          <div className="flex">
            <div className="col-1" />
            <div className="col-5 mr1">
              <DatePickerField name="dateFrom" label="Vyberte termín od" />
            </div>
            <div className="col-5 ml1">
              <DatePickerField name="dateTo" label="Do" />
            </div>
            <div className="col-1" />
          </div>
          <div className="text-center mt2">
            <Submit value="Sdílet" />
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default ShareCarPage;
